/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo } from 'react';

// Ant Design
import { Table, Row, Col, Grid } from 'antd';
import SelectedMetricList from '../components/SelectedMetricList';
import AudienceDetails from '../components/AudienceDetails';
import AudienceDetailsModal from '../components/Modals/AudienceDetailsModal.js';

import {
  demographicsAudienceTableColumn,
  demographicsAudienceTableColumnMobile,
} from '../utils/tableColumns';

import { isMobileScreen } from '../utils/mobileUtils';
import { useAudienceBuilderContext } from '../context/AudienceBuilderContext.js';


const DemographicsAudienceTable = (props) => {
  const {
    audienceDemographs,
    handleUpdateAudience,
    handleActivateAudience,
    handlePublishAudience,
    handleCreateAudience,
    handleFetchAudienceDemographs,
    handleSaveAudiencesToApi,
  } = props;

  const { jobStatusMap } = useAudienceBuilderContext();

  const { useBreakpoint } = Grid;

  const breakPoint = useBreakpoint();
  const [visbile, setVisible] = useState(false);
  const [metrics, setMetrics] = useState([]);

  const [audienceDetails, setAudienceDetails] = useState({});
  const [selected, setSelected] = useState([]);
  const [data, setData] = useState([]);
  const [manualExpandedKeys, setManualExpandedKeys] = useState([]);
  const [manualCollapsedKeys, setManualCollapsedKeys] = useState([]);

  // Auto-expand rows with active jobs (saving, activating, publishing)
  const activeJobKeys = useMemo(() => {
    return audienceDemographs
      .filter((item) => {
        const status = jobStatusMap[item.id];
        if (status && status.status === 'ACTIVE') return true;
        try {
          const meta = typeof item.prePublishedMetadata === 'string'
            ? JSON.parse(item.prePublishedMetadata)
            : item.prePublishedMetadata;
          const parsed = meta?.set || meta;
          if (parsed?.status === 'ACTIVE') return true;
        } catch {}
        return false;
      })
      .map((item) => item.id);
  }, [audienceDemographs, jobStatusMap]);

  const expandedRowKeys = useMemo(() => {
    const autoKeys = activeJobKeys.filter((k) => !manualCollapsedKeys.includes(k));
    return [...new Set([...manualExpandedKeys, ...autoKeys])];
  }, [manualExpandedKeys, manualCollapsedKeys, activeJobKeys]);

  const defaultExpandable = {
    expandedRowRender: (record) => {
      const { metrics } = record;
      return (
        <>
          <Row style={{ minHeight: '700px' }} gutter={16}>
            <Col span={6}>
              <SelectedMetricList
                list={metrics}
                loading={false}
                disableDrag={true}
                displayOnly={true}
              ></SelectedMetricList>
            </Col>
            <Col span={18} style={{ height: '700px' }}>
              <AudienceDetails
                audienceDetails={record}
                record={record}
                handleUpdateAudience={handleUpdateAudience}
                handleActivateAudience={handleActivateAudience}
                handlePublishAudience={handlePublishAudience}
                handleCreateAudience={handleCreateAudience}
                handleFetchAudienceDemographs={handleFetchAudienceDemographs}
                handleSaveAudiencesToApi={handleSaveAudiencesToApi}
              />
            </Col>
          </Row>
        </>
      );
    },
  };

  const tableProps = isMobileScreen(breakPoint)
    ? {}
    : {
        expandable: {
          ...defaultExpandable,
          expandedRowKeys,
          onExpand: (expanded, record) => {
            if (expanded) {
              setManualExpandedKeys((prev) => [...prev, record.key]);
              setManualCollapsedKeys((prev) => prev.filter((k) => k !== record.key));
            } else {
              setManualExpandedKeys((prev) => prev.filter((k) => k !== record.key));
              setManualCollapsedKeys((prev) => [...prev, record.key]);
            }
          },
        },
      };

  const tableColumns = isMobileScreen(breakPoint)
    ? demographicsAudienceTableColumnMobile
    : demographicsAudienceTableColumn;
  const handleSelectState = (x) => {
    setSelected((prevSelected) => {
      const isSelected = prevSelected.includes(x);
      if (isSelected) {
        const newSelected = prevSelected.filter((item) => item !== x);
        const newData = audienceDemographs.filter((item) =>
          newSelected.every((tag) => item.tags.includes(tag))
        );
        setData(newData);
        return newSelected;
      } else {
        const newData = audienceDemographs.filter((item) => item.tags.includes(x));
        setData(newData);
        return [...prevSelected, x];
      }
    });
  };

  const isSelected = (id) => selected.includes(id);

  const handleRowClick = (record) => {
    setAudienceDetails(record);
    setMetrics(record.metrics);
    setVisible(true);
  };

  const rowProps = (record) => ({
    onClick: () => handleRowClick(record),
  });

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <AudienceDetailsModal
        visible={visbile}
        audienceDetails={audienceDetails}
        metrics={metrics}
        handleCancel={handleCancel}
      />
      <Table
        {...tableProps}
        columns={tableColumns}
        style={{ marginTop: 16 }}
        dataSource={
          (data && data.length > 0 && selected.length > 0
            ? data
            : audienceDemographs
          ).map((i) => ({
            ...i,
            key: i.id,
            _jobStatus: jobStatusMap[i.id] || null,
          }))
        }
        pagination={{
          pageSize: 25,
          showSizeChanger: true,
          pageSizeOptions: ['10', '25', '50', '100'],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} audiences`,
        }}
        onRow={isMobileScreen(breakPoint) ? rowProps : null}
      />
    </>
  );
};

export default DemographicsAudienceTable;
